import { render, staticRenderFns } from "./LiveAccounts.vue?vue&type=template&id=58fbdb6c&scoped=true"
import script from "./LiveAccounts.vue?vue&type=script&lang=js"
export * from "./LiveAccounts.vue?vue&type=script&lang=js"
import style0 from "./LiveAccounts.vue?vue&type=style&index=0&id=58fbdb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fbdb6c",
  null
  
)

export default component.exports